import React from "react";
import "./style.css";

const Hero = () => {
  return (
    <section className="hero" id="home">
      <figure className="hero-banner">
        <picture>
          <source
            media="(min-width: 768px)"
            srcSet="./assets/images/portfolio-hero.png"
          />
          <source
            media="(min-width: 500px)"
            srcSet="./assets/images/portfolio-hero-md.png"
          />
          <img
            alt="Gonzalo de Salterain in a blue shirt with a happy expression"
            className="w-100"
            src="./assets/images/portfolio-hero-sm.png"
          />
        </picture>

        <div>
          <div className="hero-bubbles">
            <div className="hero-bubble"></div>
            <div className="hero-bubble"></div>
            <div className="hero-bubble"></div>
            <svg>
              <defs>
                <filter id="filter">
                  <feGaussianBlur
                    in="SourceGraphic"
                    stdDeviation="18"
                    result="blur"
                  />
                  <feColorMatrix
                    in="blur"
                    mode="matrix"
                    values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 28 -10"
                    result="filter"
                  />
                  <feComposite
                    in="SourceGraphic"
                    in2="filter"
                    operator="atop"
                  />
                </filter>
              </defs>
            </svg>
          </div>
        </div>
      </figure>
      <div className="hero-content">
        <h2 className="h2 hero-title">I Craft Awesome Products For You</h2>
        <a className="btn btn-primary" href="#contact">
          Get in touch
        </a>
      </div>
      <ul className="hero-social-list">
        <li>
          <a
            className="hero-social-link"
            href="https://www.facebook.com/Verlaire/"
            target="_blank"
            rel="noreferrer"
          >
            <ion-icon name="logo-facebook"></ion-icon>
            <div className="tooltip">Facebook</div>
          </a>
        </li>
        <li>
          <a
            className="hero-social-link"
            href="https://dribbble.com/Verlaire"
            target="_blank"
            rel="noreferrer"
          >
            <ion-icon name="logo-dribbble"></ion-icon>
            <div className="tooltip">Dribbble</div>
          </a>
        </li>
        <li>
          <a
            className="hero-social-link"
            href="https://www.linkedin.com/in/gsaltera/"
            target="_blank"
            rel="noreferrer"
          >
            <ion-icon name="logo-linkedin"></ion-icon>
            <div className="tooltip">Linkedin</div>
          </a>
        </li>
      </ul>
      <a className="scroll-down" href="#stats">
        Scroll
      </a>
    </section>
  );
};

export default Hero;
